/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BOOLEAN_STATUS, ENTITYNAME, KEY_ASSET_GROUP_TYPE, LOGEVENT, MODULE, OFFER_TYPE, SUBTITLING_CODE, SUBTITLING_MODE_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

export const IngestPrototypeEditForm = (props) => {
  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Description: props?.item?.copy ? "Copy of " + props?.item?.Description : props?.item?.Description ?? "",
    TransmissionType: props.item.TransmissionType ? { _id: props.item.TransmissionType.SID, Name: props.item.TransmissionType.Name } : {},
    DirectIngest: props?.item?.DirectIngest ? { _id: props.item.DirectIngest, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.DirectIngest) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    CensorshipFlag: props?.item?.CensorshipFlag ? { _id: props.item.CensorshipFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.CensorshipFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    AssetGroup: props?.item?.AssetGroup ? { _id: props.item.AssetGroup, Description: utility.getKeyByValue(KEY_ASSET_GROUP_TYPE, props.item.AssetGroup) } : {},
    DualSound: props?.item?.DualSound ? { _id: props.item.DualSound, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.DualSound) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    SubtitlesFlag: props?.item?.SubtitlesFlag ? { _id: props.item.SubtitlesFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.SubtitlesFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    SubtitlingCode: { _id: props.item.SubtitlingCode, Description: utility.getKeyByValue(SUBTITLING_CODE, props.item.SubtitlingCode) },
    SubtitlingLang: props.item.SubtitlingLang ?? "",
    SubtitlingMode: props?.item?.SubtitlingMode ? { _id: props.item.SubtitlingMode, Description: utility.getKeyByValue(SUBTITLING_MODE_TYPE, props.item.SubtitlingMode) } : { _id: props.item.SubtitlingMode, Description: utility.getKeyByValue(SUBTITLING_MODE_TYPE, SUBTITLING_MODE_TYPE.None) },
    Thumbnail: props?.item?.Thumbnail ? { _id: props.item.Thumbnail, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.Thumbnail) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    Language1: props?.item?.Language1 ?? "",
    HD: props?.item?.HD ? { _id: props.item.HD, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.HD) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
    IsDefault: props?.item?.IsDefault ?? false,
    Archive: props.item.Archive ?? false,
    Language2: props?.item?.Language2 ?? "",
    SecondaryCopy: props?.item?.SecondaryCopy ? { _id: props.item.SecondaryCopy, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.SecondaryCopy) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [subtitlingModes, setSubtitlingModes] = useState([]);
  const [assetGroups, setAssetGroups] = useState([]);

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let transmissionTypeRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { SID: 1 } });
    setTransmissionTypes(transmissionTypeRes.data);
    let subtitlingModeRes = Object.keys(SUBTITLING_MODE_TYPE).map((x) => {
      return {
        _id: SUBTITLING_MODE_TYPE[x],
        Description: x
      }
    })
    setSubtitlingModes(subtitlingModeRes);
    let assetGroupRes = Object.keys(KEY_ASSET_GROUP_TYPE).map((x) => {
      return {
        _id: KEY_ASSET_GROUP_TYPE[x],
        Description: x
      }
    })
    setAssetGroups(assetGroupRes);
  }

  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return false;
    };
    if (!dataItem.AssetGroup._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_asset_group_error_message });
      return false;
    }
    if (dataItem.Language1 && dataItem.Language1.trim().length > 3) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.language1_length_error_message });
      return false
    }
    if (dataItem.Language2 && dataItem.Language2.trim().length > 3) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.language2_length_error_message });
      return false
    }
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {

      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        Description: dataItem.Description,
        TransmissionType: dataItem?.TransmissionType && Object.keys(dataItem?.TransmissionType).length > 0 ? {
          _id: dataItem?.TransmissionType?._id,
          Name: dataItem?.TransmissionType?.Name
        } : {},
        DirectIngest: dataItem.DirectIngest._id,
        CensorshipFlag: dataItem.CensorshipFlag._id,
        AssetGroup: dataItem.AssetGroup._id,
        DualSound: dataItem.DualSound._id,
        SubtitlesFlag: dataItem.SubtitlesFlag._id,
        SubtitlingCode: dataItem.SubtitlingCode._id,
        SubtitlingLang: dataItem.SubtitlingLang ?? "",
        SubtitlingMode: dataItem.SubtitlingMode._id ?? "",
        Thumbnail: dataItem.Thumbnail._id,
        Language1: dataItem.Language1 ?? "",
        HD: dataItem.HD._id,
        IsDefault: dataItem.IsDefault ?? false,
        Archive: dataItem.Archive ?? false,
        Language2: dataItem.Language2 ?? "",
        SecondaryCopy: dataItem.SecondaryCopy._id,
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.INGEST_PROTOTYPE, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.INGEST_PROTOTYPE, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.INGEST_PROTOTYPE);
        props.cancelEdit();
        props.refresh();
      }
      else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  }

  const onChangeForm = (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else if (e.target.name == "IsDefault") {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : "Create Ingest Prototype"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row form-group mt-2">
              <div className="col-6 pb-2">
                <label>{lang.description_label} *</label>
                <input
                  name={"Description"}
                  type="text"
                  className="form-control form-control-sm"
                  onChange={onChangeForm}
                  value={dataItem.Description}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.transmission_type_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={transmissionTypes}
                  name="TransmissionType"
                  textField="Name"
                  dataItemKey="_id"
                  value={dataItem.TransmissionType}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.asset_group_label} *</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={assetGroups}
                  name="AssetGroup"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.AssetGroup}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.direct_ingest_label} *</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="DirectIngest"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.DirectIngest}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.censorship_flag_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="CensorshipFlag"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.CensorshipFlag}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.dual_sound_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="DualSound"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.DualSound}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.subtitles_flag_label} </label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="SubtitlesFlag"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.SubtitlesFlag}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.subtitling_code_label} </label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(SUBTITLING_CODE).map((obj) => {
                      return {
                        _id: SUBTITLING_CODE[obj],
                        Description: obj
                      }
                    })
                  }
                  name="SubtitlingCode"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.SubtitlingCode}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label htmlFor="">{lang.thumbnail_label} </label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="Thumbnail"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.Thumbnail}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.subtitling_lang_label} </label>
                <input
                  name={"SubtitlingLang"}
                  type="text"
                  className="form-control form-control-sm"
                  onChange={onChangeForm}
                  value={dataItem.SubtitlingLang}
                />
              </div>
              <div className="col-6 pb-2" >
                <label>{lang.subtitling_mode_label} </label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={subtitlingModes}
                  name="SubtitlingMode"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.SubtitlingMode}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label htmlFor="">{lang.language1_label}</label>
                <input
                  name={"Language1"}
                  type="text"
                  className="form-control form-control-sm"
                  onChange={onChangeForm}
                  value={dataItem.Language1}
                />
              </div>
              <div className="col-6 pb-2">
                <label htmlFor="">{lang.secondary_copy_label} </label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="SecondaryCopy"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.SecondaryCopy}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-6 pb-2">
                <label>{lang.language2_label} </label>
                <input
                  name={"Language2"}
                  type="text"
                  className="form-control form-control-sm"
                  onChange={onChangeForm}
                  value={dataItem.Language2}
                />
              </div>
              <div className="col-6 pb-2" >
                <label>{lang.hd_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={
                    Object.keys(BOOLEAN_STATUS).map((obj) => {
                      return {
                        _id: BOOLEAN_STATUS[obj],
                        Description: obj
                      }
                    })
                  }
                  name="HD"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.HD}
                  onChange={onChangeForm}
                />
              </div>
              <div className="col-3 pt-4" >
                <input type={"checkbox"} name={"IsDefault"}
                  onChange={(e) => onChangeForm(e)}
                  value={dataItem.IsDefault}
                  checked={dataItem.IsDefault} />
                <label className="ml-1">{lang.set_as_default_label}</label>
              </div>
              <div className="col-3 pt-4" >
                <input type={"checkbox"} name={"Archive"}
                  onChange={(e) => onChangeForm(e)}
                  value={dataItem.Archive}
                  checked={dataItem.Archive} />
                <label className="ml-1">{lang.archive}</label>
              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};